<template>
    <div class="d-flex align-start flex-column" v-if="haveData">
        <title-info title="Transition Risk" :url="transitionUrl">
        </title-info>
        <br>
        <v-row>
            <v-col v-for="metric in emissionsMetrics">
                <carbon-table :metric="metric"></carbon-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-for="metric in pcafMetrics">
                <carbon-table :metric="metric"></carbon-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-for="metric in energyMetrics">
                <carbon-table :metric="metric"></carbon-table>
            </v-col>
        </v-row>
    </div>
  </template>
  <script>
  import { mapState } from 'vuex'
  import { basicTransitionMetrics, hasData } from '@/utils/climate'
  import CarbonTable from '@/components/CarbonTable.vue'
  import TitleInfo from '@/components/TitleInfo.vue'

  export default {
    components: { CarbonTable, TitleInfo },
    data() {
        return {
            transitionUrl: "https://docs.level11analytics.com/p_esg_rmbs_a.html#rmbs-carbon-transition-risk",
            extraTransitionMetrics: [
            {
                name: "pcaf_attribution_factor",
                displayName: "PCAF Attribution Factor",
                units: "%"
            },
            {
                name: "co2e_kg_footprint_pcafattrib_per1000principal",
                displayName: "Financed Emissions per $1k Principal",
                units: "CO\u2082e kg"
            },
            {
                name: "kwh_electricity_total_energy_consumption_perloan",
                displayName: "Electricity Energy Consumption",
                units: "kWh"
            },
            {
                name: "kwh_heating_fuel_total_energy_consumption_perloan",
                displayName: "Heating Energy Consumption",
                units: "kWh"
            }],
            emissionsNames: ['co2e_kg_footprint_total_perloan', 'average_emissions_intensity'],
            pcafNames: ['pcaf_attribution_factor', 'co2e_kg_footprint_pcafattrib_perloan', 'co2e_kg_footprint_pcafattrib_per1000principal'],
            energyNames: ['kwh_electricity_total_energy_consumption_perloan', 'kwh_heating_fuel_total_energy_consumption_perloan']
        }
    },
    computed: {
      ...mapState({
        summaryData: state => state.summaryData
      }),
      emissionsMetrics(){
        return this.metricsFromNames(this.emissionsNames)
      },
      pcafMetrics() {
        return this.metricsFromNames(this.pcafNames)
      },
      energyMetrics() {
        return this.metricsFromNames(this.energyNames)
      },
      allMetrics() {
        return basicTransitionMetrics.concat(this.extraTransitionMetrics)
      },
      metrics() {
        return this.allMetrics.filter(this.hasData)
      },
      haveData() {
        return this.metrics.length > 0
      }
    },
    methods: {
        hasData(metric) {
            return hasData(metric, this.summaryData)
        },
        metricsFromNames(metricNames) {
            return this.metrics.filter(metric => metricNames.includes(metric.name))
        }
    }
  }
  </script>

  <style scoped>

  h3 {
    color: rgba(0, 0, 0, 0.6);
  }

  </style>
